(function (Drupal, drupalSettings) {
  Drupal.behaviors.realEstate = {
    attach: function (context, settings) {

        once('collaps-and-expand', '.read-more', context).forEach( elm => {
          const content = elm.querySelector('.content');

          const isTextClamped =  content.scrollHeight > content.clientHeight;

          if (isTextClamped) {
            const clampedHeight = content.clientHeight;
            content.style.height = clampedHeight + 'px';
            elm.classList.add('clamped');

            const showMoreButton = document.createElement('button');
            showMoreButton.classList.add('show-more');
            showMoreButton.innerHTML = 'Weiterlesen';
            showMoreButton.addEventListener('click', () => {
              elm.classList.toggle('expanded');
              elm.classList.add('animating');
              setTimeout(() => {
                elm.classList.remove('animating');
              }, 500);
              if (elm.classList.contains('expanded')) {
                showMoreButton.innerHTML = 'Weniger anzeigen';
                content.style.height = content.scrollHeight + 'px';
              } else {
                showMoreButton.innerHTML = 'Weiterlesen';
                content.style.height = clampedHeight + 'px';
              }
            });
            elm.appendChild(showMoreButton);
          }
        });



      once('real-estate-statistics', '.real-estate-page-marker', context).forEach(el => {
        if (drupalSettings.prop_type.property_id) {
          fetch('/prop-api/statistics?_format=json', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              'property_id': drupalSettings.prop_type.property_id,
              'type': 'pageview',
            })
          });
        }
      });

      window.addEventListener('DOMContentLoaded', function (e) {
        const elementToCheck = document.getElementById('re-provider-contact-static');
        const fixedContact = document.getElementById('re-provider-contact-fixed');
        console.log("elementToCheck", elementToCheck);
        if (!elementToCheck) {
          return;
        }
        hideShowFixedContact(elementToCheck, fixedContact);
        window.addEventListener('scroll', (event) => {
          hideShowFixedContact(elementToCheck, fixedContact)
        });
      });
    },
  };

  function hideShowFixedContact(elementToCheck, fixedContact) {
    if (isInViewport(elementToCheck)) {
      fixedContact.classList.remove("lg:block");
      fixedContact.classList.add("lg:hidden");
    } else {
      fixedContact.classList.remove("lg:hidden");
      fixedContact.classList.add("lg:block");
    }
  }

  function isInViewport(value) {
    const item = value.getBoundingClientRect();
    return (item.top >= 0 && item.left >= 0 && item.bottom <= (window.innerHeight || document.documentElement.clientHeight) && item.right <= (window.innerWidth || document.documentElement.clientWidth));
  }
})(Drupal, drupalSettings);

